export const theme = {
  textColor: "#fff",
};
